import Notify from 'quasar/src/plugins/notify/Notify.js';;

export const helperNotify = {
  getErrorMessage(message) {
    let localMessage = '';
    if(typeof(message) == 'object') {
      localMessage = !Object.values(message).length ? message.toString() : JSON.stringify(message);
    } else if(typeof(message) == 'string') {
      localMessage = message;
    } else {
      localMessage = message.toString();
    }
    return localMessage;
  },

  success(caption = '', message, opts = {}) {
    const params = Object.assign(
      {},
      {
        classes: 'helper-notify',
        actions: [{ icon: 'close', color: 'white', round: true, handler: () => { /* ... */ } }],
        type: 'positive',
        position: 'top-right',
        caption: `<span class="text-weight-bold text-white" style="font-size:1.1rem; line-height:1.75rem; letter-spacing:0.00937em;">${this.getErrorMessage(message)}</span>`,
        message: `<span class="text-h6 text-weight-bold text-white">${caption}</span>`,
        html: true,
        textColor: 'grey-1'
      },
      opts
    );
    return Notify.create(params);
  },

  info(caption = '', message, opts = {}) {
    const params = Object.assign(
      {},
      {
        classes: 'helper-notify',
        actions: [{ icon: 'close', color: 'white', round: true, handler: () => { /* ... */ } }],
        type: 'info',
        position: 'top-right',
        caption: `<span class="text-weight-bold text-white" style="font-size:1.1rem; line-height:1.75rem; letter-spacing:0.00937em;">${this.getErrorMessage(message)}</span>`,
        message: `<span class="text-h6 text-weight-bold text-white">${caption}</span>`,
        html: true,
        textColor: 'grey-1'
      },
      opts
    );
    return Notify.create(params);
  },

  warning(caption = '', message, opts = {}) {
    const params = Object.assign(
      {},
      {
        classes: 'helper-notify',
        actions: [{ icon: 'close', color: 'white', round: true, handler: () => { /* ... */ } }],
        type: 'warning',
        position: 'top-right',
        caption: `<span class="text-weight-bold text-white" style="font-size:1.1rem; line-height:1.75rem; letter-spacing:0.00937em;">${this.getErrorMessage(message)}</span>`,
        message: `<span class="text-h6 text-weight-bold text-white">${caption}</span>`,
        html: true,
        textColor: 'grey-1'
      },
      opts
    );
    return Notify.create(params);
  },

  error(caption = '', message, opts = {}) {
    const params = Object.assign(
      {},
      {
        classes: 'helper-notify',
        actions: [{ icon: 'close', color: 'white', round: true, handler: () => { /* ... */ } }],
        type: 'negative',
        position: 'top-right',
        caption: `<span class="text-weight-bold text-white" style="font-size:1.1rem; line-height:1.75rem; letter-spacing:0.00937em;">${this.getErrorMessage(message)}</span>`,
        message: `<span class="text-h6 text-weight-bold text-white">${caption}</span>`,
        html: true,
        textColor: 'grey-1'
      },
      opts
    );
    return Notify.create(params);
  },
};

export default helperNotify;
